import React from 'react';
import { RefreshCwIcon, ShieldCheckIcon, HeartPulseIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const SERVICES = [{
  title: 'Prescription Refills',
  description: 'Quick and easy online refill requests with automatic notifications when your order is ready.',
  icon: <RefreshCwIcon className="w-8 h-8" data-id="element-179" />,
  link: '/prescriptions'
}, {
  title: 'Immunizations',
  description: 'Walk-in flu shots, COVID-19 boosters, and travel vaccinations administered by certified pharmacists.',
  icon: <ShieldCheckIcon className="w-8 h-8" data-id="element-180" />,
  link: '/services'
}, {
  title: 'Health Consulting',
  description: 'One-on-one medication reviews and personalized wellness plans tailored to your health goals.',
  icon: <HeartPulseIcon className="w-8 h-8" data-id="element-181" />,
  link: '/services'
}];
export function ServicesGrid() {
  return <section className="py-24 bg-slate-50 border-y border-slate-100" data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <div className="text-center mb-16" data-id="element-184">
          <h2 className="text-3xl font-extrabold text-slate-900 mb-4" data-id="element-185">
            Clinical Services
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto" data-id="element-186">
            Beyond retail, we provide professional clinical care to support your
            long-term health and wellness.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-12" data-id="element-187">
          {SERVICES.map((service, idx) => <div key={idx} className="flex flex-col items-center text-center" data-id="element-188">
              <div className="w-16 h-16 rounded-2xl bg-white shadow-sm border border-slate-100 flex items-center justify-center text-clinical-blue mb-6" data-id="element-189">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-190">
                {service.title}
              </h3>
              <p className="text-slate-500 text-sm leading-relaxed mb-6" data-id="element-191">
                {service.description}
              </p>
              <Link to={service.link} className="text-clinical-blue text-sm font-bold flex items-center gap-1 hover:underline" data-id="element-192">
                View Details <ChevronRightIcon className="w-4 h-4" data-id="element-193" />
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}